import './polyfills';
import BugsnagPerformance from '@bugsnag/browser-performance';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

// Console warning for security
console.log(
    '%cPERHATIAN',
    'background: linear-gradient(to right, #006944, #ffd709); color: white; font-size: 60px; font-weight: bold; padding: 10px 40px; border-radius: 20px; text-shadow: 2px 2px 5px rgba(0,0,0,0.5); font-family: sans-serif; display: block; text-align: center;',
);
console.log(
    '%cJangan menempelkan (paste) apa pun di sini. Jika seseorang menyuruh Anda menyalin dan menempelkan sesuatu di sini, itu adalah upaya penipuan yang dapat memberikan akses ke akun Anda kepada orang lain.',
    'font-size: 18px; font-weight: bold; color: #181c1b; font-family: sans-serif; margin-top: 10px;',
);
console.log(
    '%cMenemukan celah keamanan? Sampaikan kepada kami dengan melihat /.well-known/security.txt\nFound a security vulnerability? Let us know by checking /.well-known/security.txt',
    'font-size: 14px; color: #006944; font-weight: bold; font-family: sans-serif; margin-top: 10px;',
);

import { createInertiaApp, router } from '@inertiajs/react';
import { LazyMotion } from 'framer-motion';
import React from 'react';
import { toast } from 'sonner';
import { Workbox } from 'workbox-window';

import { ErrorBoundary } from '@/components/error-boundary';
import { PwaInstallPrompt } from '@/components/pwa-install-prompt';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { initializeTheme } from '@/hooks/use-appearance';
import AppLayout from '@/layouts/app-layout';
import AuthLayout from '@/layouts/auth-layout';
import SantriLayout from '@/layouts/santri-layout';
import SettingsLayout from '@/layouts/settings/layout';

const loadFramerFeatures = () =>
    import('framer-motion').then((res) => res.domAnimation);

const bugsnagKey = import.meta.env.VITE_BUGSNAG_API_KEY;
const appVersion = import.meta.env.VITE_APP_VERSION;

if (bugsnagKey) {
    Bugsnag.start({
        apiKey: bugsnagKey,
        appVersion: appVersion,
        plugins: [new BugsnagPluginReact()],
    });
    BugsnagPerformance.start({ apiKey: bugsnagKey });
}


const BugsnagErrorBoundary =
    Bugsnag.getPlugin('react')?.createErrorBoundary(React) ||
    (({ children }: { children: React.ReactNode }) => <>{children}</>);

if ('serviceWorker' in navigator) {
    // Unregister the old broken SW if it exists
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
            if (registration.active?.scriptURL.includes('/build/sw.js')) {
                registration.unregister();
                console.log('Unregistered old SW at /build/sw.js');
            }
        }
    });

    const wb = new Workbox('/sw.js');
    wb.register().catch((err) => {
        console.warn('Service Worker registration failed:', err);
    });
}

const appName = import.meta.env.VITE_APP_NAME || 'Sistem Presensi Santri';

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    layout: (name) => {
        switch (true) {
            case name === 'welcome' || name === 'error':
                return null;
            case name.startsWith('auth/'):
                return AuthLayout;
            case name.startsWith('admin/'):
                return AppLayout;
            case name.startsWith('settings/'):
                return [AppLayout, SettingsLayout];
            default:
                return SantriLayout;
        }
    },
    strictMode: true,
    withApp(app) {
        return (
            <BugsnagErrorBoundary>
                <ErrorBoundary>
                    <TooltipProvider delayDuration={0}>
                        <LazyMotion features={loadFramerFeatures}>
                            {app}
                        </LazyMotion>
                        <PwaInstallPrompt />
                        <Toaster />
                    </TooltipProvider>
                </ErrorBoundary>
            </BugsnagErrorBoundary>
        );
    },
    progress: {
        color: '#006944',
    },
});

// This will set light / dark mode on load...
initializeTheme();

// Global Error Handlers for Inertia v3
router.on('networkError', (event) => {
    toast.error(
        'Koneksi internet terputus atau tidak stabil. Silakan coba lagi.',
    );
    event.preventDefault(); // Prevent default crash behavior
});

router.on('httpException', (event) => {
    // If it's a server error (500), show a toast instead of a modal
    if (event.detail.response.status >= 500) {
        toast.error(
            'Terjadi kesalahan pada server. Tim teknis telah diberitahu.',
        );
        event.preventDefault();
    }
});
